import nanoid from 'nanoid/generate';
import { alphabet, length } from '../../constants/id-suffix';

function generateIdSuffix() {
  return `-${nanoid(alphabet, length)}`;
}

export default generateIdSuffix;
